import {$, HttpIgnore, Model, ResponseFill} from 'simpli-web-sdk'
import EmailAlertaNotaAtraso from '@/model/resource/EmailAlertaNotaAtraso'

@HttpIgnore()
export default class PersistEmailAlertaNotaAtrasoRequest extends Model {
  readonly $name: string = 'PersistEmailAlertaNotaAtrasoRequest'

  @ResponseFill()
  emails: EmailAlertaNotaAtraso[] = []

  async persistEmailAlertaNotaAtraso(spinner = 'persistEmailAlertaNotaAtraso') {
    const fetch = async () => {
      return await this.POST('/user/email-alerta-nota-atraso', this)
    }

    return await $.await.run(fetch, spinner)
  }
}
